import { Clock } from "@gravity-ui/icons";
import { Flex, Icon, Label, Text } from "@gravity-ui/uikit";
import { PublicAlert } from "definitions/poizon-bff";

import { severityInfo } from "../../ServiceStatusPage.constants.tsx";
import { formatIncidentDuration } from "../../ServiceStatusPage.utils.ts";
import css from "./AlertRow.module.scss";

interface AlertRowProps {
  alert: PublicAlert;
}

export const AlertRow = ({ alert }: AlertRowProps) => {
  const severity = severityInfo[alert.severity];
  const duration = formatIncidentDuration(alert.since);

  return (
    <Flex gap={2} alignItems="flex-start" className={css.alert}>
      <Label theme={severity.theme} size="s" className={css.alertSeverity}>
        {severity.label}
      </Label>
      <Flex direction="column" gap={1}>
        <Text variant="body-2">{alert.summary}</Text>
        {duration && (
          <Flex gap={1} alignItems="center" className={css.alertMeta}>
            <Icon data={Clock} size={13} />
            <Text variant="caption-2" color="secondary">
              {duration}
            </Text>
          </Flex>
        )}
      </Flex>
    </Flex>
  );
};
